import { log } from '@/src/common/logger/logger'

export interface Params {
  baseUrl: string
  beforeRequest?: (url: string, options: RequestInit) => Promise<RequestInit>
  afterRequest?: (url: string, options: RequestInit, response: Response) => Promise<Response | null>
}
export const customFetch = (params: Params) => {
  return async function newFetch(url: string, options: RequestInit = {}) {
    const newRequestObject = await params?.beforeRequest?.(url, options)

    // Never log options.body — it carries credentials on auth/login.
    log(`${options.method}: Requesting ${url}`)

    const port = getPort(params.baseUrl)

    const fetchRequest = await fetch(params.baseUrl + port + `/` + url, {
      ...(newRequestObject || options),
      headers: {
        ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
        'client-platform': 'browser',
        Accept: 'application/json',
        ...(newRequestObject?.headers || options?.headers),
      },
      // Ensure cookies are sent to the API (required for cross-origin localhost:3000 -> 8080)
      credentials: 'include',
      ...(!options.next && options.cache !== 'force-cache' ? { cache: options.cache || 'no-store' } : {}),
    })

    log(`Response: ${fetchRequest.status} ${url}`)

    // If response says remove cookie, remove it

    if (params?.afterRequest) {
      const result = await params?.afterRequest?.(url, options, fetchRequest)

      if (result) {
        return result
      }
    }

    return fetchRequest
  }
}

export const getPort = (url: string) => {
  // Append default dev port for localhost only when no explicit port is present
  try {
    const u = new URL(url)
    if (u.port) return ''
    if (u.hostname === 'localhost') return ':8080'
  } catch (_) {
    if (url.startsWith('http://localhost') || url.startsWith('https://localhost')) {
      return ':8080'
    }
  }
  return ''
}
